import { INavigateToPageBase } from '@wix/business-manager-api';

export interface baseDealerOffer {
  offerName: string;
  title: string;
  body: string;
  mainButtonText: string;
  mainButtonConfig: CrmButtonAction;
  secondaryButtonText?: string;
  secondaryButtonConfig?: CrmButtonAction;
  illustration: string;
}

export interface CardDealerOffer extends baseDealerOffer {}

export interface CrmHomeBannerOffer extends baseDealerOffer {
  video?: string;
}

export enum CrmButtonActionType {
  NAVIGATE = 'NAVIGATE',
  INVOKE = 'INVOKE',
}

interface BaseOpts {
  withContactId?: boolean;
}
export interface NavigateToCTAOpts extends BaseOpts {
  type: CrmButtonActionType.NAVIGATE;
  payload: INavigateToPageBase;
}

export interface InvokeCTAOpts extends BaseOpts {
  type: CrmButtonActionType.INVOKE;
  method: string;
  payload: any;
}

export interface CrmButtonAction {
  key: string;
  value: NavigateToCTAOpts | InvokeCTAOpts;
}

export enum IntegrationEntities {
  GMAIL = 'gmail',
  FACEBOOK_PAGE = 'facebook-page',
  FACEBOOK_PIXEL = 'facebook-pixel',
  GOOGLE_ANALYTICS = 'google-analytics',
}

export interface FinanceAppData {
  slug: string;
  name: string;
  description: string;
  icon: string;
  installed: boolean;
}
